import { obtenerCatalogo } from "../listas/obtenerCatalogo";

/**
 * Método que retorna el nombre de la localidad
 * @param {Number} idLocalidad 
 * @returns String de la localidad
 */
export const obtenerNombreLocalidad = async idLocalidad => {
    let nombreLocalidad = String();
    try {
        const lista = await obtenerCatalogo("/api/localidad/lista", "Imposible obtener catálogo: Localidades");
        for (let i = 0; i < lista.length; i++) {
            if (Number(lista[i].idLocalidad) === Number(idLocalidad)) {
                nombreLocalidad = lista[i].nombre;
                break;
            }
        }
        return nombreLocalidad;
    }
    catch (error) {
        return nombreLocalidad;
    }
}